import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    shippingZipCode: state.customCreateAccountForm.fieldValues.shippingZipCode,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const shippingZipCodeWidget: React.FC<Props> = ({ previouslyPurchased, shippingZipCode, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Zip Code");
    const isRequired = !previouslyPurchased || previouslyPurchased === "false";
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, shippingZipCode, "shippingZipCode", () =>
        validateFieldBy(isRequired, label, shippingZipCode, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "shippingZipCode", value: event.target.value });
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={shippingZipCode || ""}
            error={fieldErrorMessage}
            maxLength={5}
            onChange={fieldChangeHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(shippingZipCodeWidget);
